import configuration from '~/configuration'
import { getCookie, setCookie } from '~/core/generic/cookies'
import { THEME_COOKIE_NAME } from '~/lib/server/cookies/theme.cookie'


export const DARK_THEME_CLASSNAME = `dark`
export const LIGHT_THEME_CLASSNAME = `light`
export const SYSTEM_THEME_CLASSNAME = 'system'
export const DEFAULT_THEME = configuration.theme

export function getStoredTheme() {
  if (typeof document === 'undefined')
    return DEFAULT_THEME
  try {
    return getCookie(THEME_COOKIE_NAME) ?? DEFAULT_THEME
  }
  catch (error) {
    console.error('Failed to get stored theme:', error)
    return DEFAULT_THEME
  }
}

export function setTheme(theme: string | null) {
  if (typeof document === 'undefined')
    return

  setCookie(THEME_COOKIE_NAME, theme || DEFAULT_THEME)
}

export function switchTheme(theme: string | null) {
  const root = document.documentElement
  
  // Clean up existing theme classes
  root.classList.remove(DARK_THEME_CLASSNAME, LIGHT_THEME_CLASSNAME)

  // Apply appropriate theme
  if (theme === DARK_THEME_CLASSNAME || 
      (theme === SYSTEM_THEME_CLASSNAME && isDarkSystemTheme()) ||
      (theme === null && isDarkSystemTheme())) {
    root.classList.add(DARK_THEME_CLASSNAME)
  } else if (theme === LIGHT_THEME_CLASSNAME || 
            (theme === SYSTEM_THEME_CLASSNAME && !isDarkSystemTheme()) ||
            (theme === null && !isDarkSystemTheme())) {
    root.classList.add(LIGHT_THEME_CLASSNAME)
  }

  setTheme(theme)
}



export function isDarkSystemTheme() {
  if (typeof window === 'undefined')
    return false
  return window.matchMedia('(prefers-color-scheme: dark)').matches
}

export function loadSelectedTheme() {
  if (typeof document === 'undefined')
    return
  setTheme(getStoredTheme())
}
